type ShortcodeAjaxConfig = {
  ajax_url: string;
  nonce: string;
};

type ShortcodeRenderResponse = {
  success: boolean;
  data?: {
    html?: string;
    wizard_id?: string;
  };
};

type LoadedShortcode = {
  html: string;
  wizardId: string;
} | null;

function getShortcodeConfig(): ShortcodeAjaxConfig | null {
  const config =
    (window as any).shortcode_ajax || (window as any).ryb_connect_ajax;

  if (!config?.ajax_url || !config?.nonce) {
    console.warn(
      "shortcode_ajax/ryb_connect_ajax config missing; skipping invite-only shortcode load."
    );
    return null;
  }

  return config;
}

function getWizardIdFromShortcode(shortcode: string): string {
  const match = shortcode.match(/id\s*=\s*["']([^"']+)["']/i);
  return match?.[1] || "";
}

function getFallbackShortcodeKey(shortcode: string): string {
  const normalized = shortcode.trim().replace(/\s+/g, " ");
  let hash = 0;

  for (let i = 0; i < normalized.length; i++) {
    hash = (hash << 5) - hash + normalized.charCodeAt(i);
    hash |= 0;
  }

  return `shortcode_${Math.abs(hash)}`;
}

function cacheShortcode(html: string, wizardId: string): void {
  if (!wizardId) {
    return;
  }

  (window as any).theShortcodeApp = {
    ...((window as any).theShortcodeApp || {}),
    [wizardId]: {
      html,
      wizardId,
    },
  };
}

export function loadShortcode(shortcode: string): Promise<LoadedShortcode> {
  const shortcodeConfig = getShortcodeConfig();
  if (!shortcodeConfig) {
    return Promise.resolve(null);
  }

  const wizardIdFromShortcode = getWizardIdFromShortcode(shortcode);
  const shortcodeKey = wizardIdFromShortcode || getFallbackShortcodeKey(shortcode);
  const cachedShortcode = (window as any).theShortcodeApp?.[shortcodeKey];

  if (cachedShortcode?.html) {
    return Promise.resolve({
      html: cachedShortcode.html,
      wizardId: cachedShortcode.wizardId || shortcodeKey,
    });
  }

  return new Promise((resolve) => {
    $.ajax({
      url: shortcodeConfig.ajax_url,
      type: "POST",
      data: {
        action: "render_shortcode",
        shortcode,
        nonce: shortcodeConfig.nonce,
      },
      success: function (response: ShortcodeRenderResponse) {
        if (!response?.success) {
          console.error("Failed to render shortcode:", response?.data);
          resolve(null);
          return;
        }

        const html = response.data?.html || "";
        const wizardId =
          response.data?.wizard_id || wizardIdFromShortcode || shortcodeKey;

        if (!html) {
          console.error("Shortcode render response missing html.");
          resolve(null);
          return;
        }

        cacheShortcode(html, wizardId);
        if (wizardIdFromShortcode && wizardIdFromShortcode !== wizardId) {
          cacheShortcode(html, wizardIdFromShortcode);
        }
        if (shortcodeKey !== wizardId) {
          cacheShortcode(html, shortcodeKey);
        }

        resolve({ html, wizardId });
      },
      error: function (_xhr, _status, error) {
        console.error("AJAX error:", error);
        resolve(null);
      },
    });
  });
}

export function handlePreloadingOfShortcodes(shortcode: string) {
  void loadShortcode(shortcode);
}
